import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useIntl } from "react-intl";
import { ExamTypeTranslationKey } from "../../../../model/Exam";
import { ModuleExamForSignupViewModel } from "../../../../model/ExamSignup/ExamSessionForSignupViewModel";
import { GetTranslatedValueIntl } from "../../../../model/Shared/TranslatedValue";
import { GetTranslation } from "../../../../translations/GetTranslation";

type ModuleExamListProps = {
  exams: ModuleExamForSignupViewModel[];
};

const useStyles = makeStyles({
  list: {
    paddingInlineStart: 0,
    marginBlockStart: 0,
    marginBlockEnd: 0,
  },
});

const ModuleExamList: React.FunctionComponent<ModuleExamListProps> = ({ exams }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      {exams.map((exam) => (
        <li key={exam.id}>
          {GetTranslatedValueIntl(intl, exam.name) +
            " - " +
            GetTranslation(intl, ExamTypeTranslationKey[exam.type])}
        </li>
      ))}
    </ul>
  );
};

export default ModuleExamList;
